<template>
  <div id="page-advertiser-view">
    <vx-title-bar :route="$route" :isRTL="$vs.rtl">
      <vs-dropdown
        vs-trigger-click
        class="ml-auto md:block hidden cursor-pointer"
      >
        <vs-button radius icon="icon-more-vertical" icon-pack="feather" />
        <vs-dropdown-menu class="w-32">
          <vs-dropdown-item>
            <div @click="editRecord" class="flex items-center">
              <feather-icon
                icon="EditIcon"
                class="inline-block mr-2"
                svgClasses="w-4 h-4"
              />
              <span>{{ this.$t("Edit") }}</span>
            </div>
          </vs-dropdown-item>
          <vs-dropdown-item>
            <div @click="confirmDeleteRecord" class="flex items-center">
              <feather-icon
                icon="TrashIcon"
                class="inline-block mr-2"
                svgClasses="w-4 h-4"
              />
              <span>{{ this.$t("Delete") }}</span>
            </div>
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </vx-title-bar>
    <vs-alert
      color="danger"
      title="Advertiser Not Found"
      :active.sync="advertiser_not_found"
    >
      <span>
        Advertiser record with id
        <strong>{{ $route.params.advertiserId }}</strong> not found.
      </span>
      <span>
        <span>Check</span>
        <router-link
          :to="{ name: 'advertiser-list' }"
          class="text-inherit underline"
          >{{ this.$t("Advertiser.List") }}</router-link
        >
      </span>
    </vs-alert>

    <div id="advertiser-data" v-if="advertiser_data">
      <vx-card :title="this.$t('Advertiser.Title')" class="mb-base">
        <div class="vx-row">
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">
                  {{ this.$t("Advertiser.OrganisationName") }}
                </td>
                <td>{{ advertiser_data.organisationName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ this.$t("Advertiser.Name") }}</td>
                <td>{{ advertiser_data.name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">
                  {{ this.$t("Advertiser.ProviderName") }}
                </td>
                <td>{{ advertiser_data.providerName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">
                  {{ this.$t("Advertiser.AgencyName") }}
                </td>
                <td>{{ advertiser_data.agencyName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">
                  {{ this.$t("Advertiser.AdvertiserIdDetail") }}
                </td>
                <td>{{ advertiser_data.advertiserId }}</td>
              </tr>
              <tr>
                <td class="font-semibold">
                  {{ this.$t("Advertiser.OwnerName") }}
                </td>
                <td>{{ advertiser_data.customerDisplayName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">
                  {{ this.$t("Advertiser.OwnerEmail") }}
                </td>
                <td>{{ advertiser_data.customerEmail }}</td>
              </tr>
              <tr>
                <td class="font-semibold">
                  {{ $t("Advertiser.IsPremiumDetail") }}
                </td>
                <td>
                  <DxCheckBox
                    :value="advertiser_data.isPremium"
                    :disabled="true"
                  />
                </td>
              </tr>
            </table>
          </div>
        </div>
      </vx-card>
    </div>
    <vx-card :title="$t('Advertiser.Campaigns')" class="mb-base">
      <campaign-list :idAdvertiser="idAdvertiser"></campaign-list>
    </vx-card>
  </div>
</template>

<script>
import moduleAdvertiserManagement from '@/store/advertiser-management/moduleAdvertiserManagement.js'
import CampaignList from './CampaignList'
import { DxCheckBox } from 'devextreme-vue/check-box';
import { notifyMixin } from '@/mixins/notifyMixin'

export default {
  mixins: [notifyMixin],
  data () {
    return {
      idAdvertiser: this.$route.params.advertiserId | 0,
      advertiser_data: null,
      advertiser_not_found: false
    }
  },
  components: {
    DxCheckBox,
    CampaignList
  },
  methods: {
    editRecord () {
      this.$router.push(`/advertiser/edit/${this.advertiser_data.id}`).catch(() => { })
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        text: this.$t('Advertiser.DeleteQuestion', { name: this.advertiser_data.name }),
        accept: this.deleteRecord,
        acceptText: this.$t('Delete'),
        cancelText: this.$t("Cancel")
      })
    },
    deleteRecord () {
      this.$store.dispatch('advertiserManagement/removeRecord', this.advertiser_data.id)
        .then(() => {
          this.$router.push({ name: 'advertiser-list' });
          this.notifySuccess(this.$t("Advertiser.Deleted"))
        })
        .catch(err => { console.error(err) })

    }
  },
  created () {
    // Register Module AdvertiserManagement Module
    if (!moduleAdvertiserManagement.isRegistered) {
      this.$store.registerModule('advertiserManagement', moduleAdvertiserManagement)
      moduleAdvertiserManagement.isRegistered = true
    }

    const advertiserId = this.$route.params.advertiserId
    this.$store.dispatch('advertiserManagement/fetchAdvertiser', advertiserId)
      .then(res => {
        this.advertiser_data = res.data.advertiser
        if (this.advertiser_data === null) {
          this.advertiser_not_found = true
        }
      })
      .catch(err => {
        if (err.response.status === 404) {
          this.advertiser_not_found = true
          return
        }
        console.error(err)
      })
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-advertiser-view {
  table {
    td {
      vertical-align: top;
      min-width: 250px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }
  }
}
</style>
